import { ConfirmDialog } from "@packages/core-client/forms/ConfirmDialog.tsx";
import { useI18nextInstance } from "@squide/i18next";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { i18NextInstanceKey } from "../../i18n/i18next.ts";

export interface RemovePersonDialogProps {
    isOpen: boolean;
    onOpenChange: (isOpen: boolean) => void;
    onConfirm: () => void;
    isRemoving: boolean;
}

export function RemovePersonDialog({ isOpen, onOpenChange, onConfirm, isRemoving }: RemovePersonDialogProps) {
    const i18nextInstance = useI18nextInstance(i18NextInstanceKey);
    const { t } = useTranslation("RemovePersonDialog", { i18n: i18nextInstance });

    const handleCancel = useCallback(() => onOpenChange(false), [onOpenChange]);

    return (
        <ConfirmDialog
            isOpen={isOpen}
            title={t("title")}
            description={t("body")}
            confirmLabel={t("confirm")}
            cancelLabel={t("cancel")}
            confirmIntent="danger"
            confirmationLabel={t("confirmationLabel")}
            isConfirming={isRemoving}
            onConfirm={onConfirm}
            onCancel={handleCancel}
            confirmName="remove-person"
        />
    );
}
